import { SearchContext } from './search-context.model';

export class AzureSearchResult<T> {
    odata: any;
    search: SearchContext;
    value: Array<T> = [];
}
